export default __webpack_public_path__ + "static/media/image_china.55bbfd56.png";